import type { ReactNode } from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { toneClass, type Tone } from "./tone";

export const StatusPill = ({
  tone,
  children,
  className,
}: {
  tone: Tone;
  children: ReactNode;
  className?: string;
}) => (
  // Every tone uses its soft surface so status pills read as one family.
  <Badge variant="outline" className={cn(toneClass(tone, "soft"), className)}>
    {children}
  </Badge>
);
